import DailyDataAnalysis from "@/pages/dataAnalysis/dailyDataAnalysis";
import type { DailyDataAnalysisResponse, DataOverviewResponse } from "@/types/dataAnalysis";
import request from "@/utils/request";

export const fetchDataOverview = async (query: any): Promise<DataOverviewResponse> => {
    const res = await request.post<DataOverviewResponse>('/dashboard/overview', { ...query });
    return res;
};

export const fetchDailyDataAnalysis = async (query: any, page_no: number, page_size: number): Promise<any> => {
    const res = await request.post<DailyDataAnalysisResponse>('/dashboard/daily/report', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            date: item.date,
            newUsers: item.new_users_count,
            activeUsers: item.active_users_count,
            totalDeposits: item.total_deposit_amount,
            totalTradingVolume: item.total_trade_volume,
            totalFees: item.total_fee,
            totalCommission: item.total_commission
        })),
        total: res.total
    };
}